import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlePreviewSection() {
  const recentArticles = articles.slice(0, 3);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              最新文章
            </h2>
            <p className="text-foreground-500 text-sm">
              使用指南、安全公告与平台动态
            </p>
          </div>
          <Link
            to="/category/guide"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {recentArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block p-5 rounded-lg bg-background-50 border border-secondary-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-2 mb-3">
                <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium">
                  {article.category === 'guide' ? '使用指南' : article.category === 'faq' ? '常见问题' : article.category === 'security' ? '安全公告' : '平台动态'}
                </span>
                <span className="text-xs text-foreground-400">{article.date}</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                {article.excerpt}
              </p>
              <div className="flex items-center gap-4 mt-4 pt-4 border-t border-secondary-100">
                <span className="text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-eye-line" />
                  {article.views.toLocaleString()}
                </span>
                <span className="text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-time-line" />
                  {article.readTime}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}